import { render } from "./RecallInquiryContainer.vue?vue&type=template&id=2e24a5c4"
import script from "./RecallInquiryContainer.vue?vue&type=script&lang=js"
export * from "./RecallInquiryContainer.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__